import {
  ROUTINE_GET_ENTITIES,
  ROUTINE_SET_EDITED,
  ROUTINE_SET_EDITED_ROUTINE_DAYS,
  ROUTINE_SET_ROUTINE_DAYS,
  ROUTINE_SET_RESTAURANTS_ROUTINE_DAYS
} from "../action-types/routine-days-types";

interface IRoutinesState {
  edited: boolean;
  id: number;
  restaurantId: number;
  deliveryDays: string[];
  createdAt: string;
  updatedAt: string;
  loading: boolean;
  loaded: boolean;
}

const initialState: IRoutinesState = {
  edited: false,
  id: 0,
  restaurantId: 0,
  deliveryDays: [],
  loading: false,
  loaded: false,
  createdAt: '',
  updatedAt: '',
};

export default function routinesDaysReducer (state = initialState, action) {
  switch (action.type) {
    case ROUTINE_SET_EDITED_ROUTINE_DAYS:
      return {
        ...state,
        deliveryDays: [...action.payload],
      };
    case ROUTINE_GET_ENTITIES.REJECTED:
    case ROUTINE_GET_ENTITIES.REQUEST:
    case ROUTINE_SET_RESTAURANTS_ROUTINE_DAYS.REQUEST:
    case ROUTINE_SET_ROUTINE_DAYS.REQUEST:
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    case ROUTINE_SET_ROUTINE_DAYS.SUCCESS:
    case ROUTINE_GET_ENTITIES.SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        id: action.payload.data.id,
        restaurantId: action.payload.data.restaurantId,
        deliveryDays: Object.keys(action.payload.data).length !== 0
          ? [...action.payload.data.deliveryDays]
          : [],
        createdAt: action.payload.data.createdAt,
        updatedAt: action.payload.data.updatedAt,
      };
    case ROUTINE_SET_RESTAURANTS_ROUTINE_DAYS.SUCCESS:
    case ROUTINE_SET_RESTAURANTS_ROUTINE_DAYS.REJECTED:
    case ROUTINE_SET_ROUTINE_DAYS.REJECTED:
      return {
        ...state,
        loading: false,
        loaded: true,
      };
    case ROUTINE_SET_EDITED:
      return {
        ...state,
        edited: action.payload,
      };
    default:
      return state;
  }
}
